import React, { useEffect, useState } from 'react';
import {  Table,  TableHeader,  TableBody,  TableColumn,  TableRow,  TableCell} from "@nextui-org/table";
import AthleteAdd from './Modals/athlete-add';
import { athletes_uri } from '../../../utils/url';
import axios from 'axios';
import { Input, Spinner } from '@nextui-org/react';
import Paginations from '../../../components/Pagination';
import Amjiltuud from './Modals/amjiltuud';
import { MdDelete } from 'react-icons/md';

const Athletes = () => {
    const [data, setData] = useState([]);
    const [username, setUsername] = useState("");
    const [pagination, setPagination] = useState({limit:20, all:'', totalPage:''});
    const [page, setPage] = useState(1);
    const [load, setLoad] = useState(false);

    function callback(){
        Get();
    }

    const Get = async () => {
        setLoad(true);
        try{
          const res = await axios.get(athletes_uri+`?username=${username}&page=${page}&limit=${pagination.limit}`);
          setPagination({...pagination, all:res.data.all, totalPage:res.data.totalPage});
          setData(res.data.data);
          setLoad(false);
        }catch(err){
          setLoad(false);
          console.log(err);
        }
      }
    
      useEffect(() => {
        Get();
      }, [page]);
    
      const handleKeySub = (event) => {
        if (event.key === 'Enter') {
          Get();
        }
      };
    
      const changePage = (page) => {
        setPage(page);
      };
      
      const handleDelete = async (id) => {
        setLoad(true);
        try{
          await axios.delete(athletes_uri+`/delete/${id}`);
          Get();
        }catch(err){
          console.log(err);
        }finally{
          setLoad(false);
        }
      }

  return (
    <div>
        <div className='bg-white p-4 rounded-lg'>
            <div className='flex justify-between items-center'>
                <h1>Тамирчид</h1>
                <div>
                    <AthleteAdd callback={callback}/>
                </div>
            </div>
        </div>
        <div className='mt-2 bg-white rounded-xl p-4'>
            <Input size='xs' onKeyDown={handleKeySub} value={username} onChange={(e)=> setUsername(e.target.value)} className='mb-4 rounded-full' placeholder='Хайлт хийх' rounded="full"/>
            <Table aria-label="Example static collection table">
                <TableHeader>
                    <TableColumn>Тамирчин</TableColumn>
                    <TableColumn>Төрсөн он</TableColumn>
                    <TableColumn></TableColumn>
                    <TableColumn></TableColumn>
                </TableHeader>
                <TableBody>
                    {
                        data.map((it, index) => {
                            return(
                                <TableRow key={index}>
                                    <TableCell>
                                        <div className='flex items-center gap-2'>
                                            <img src={it.profile_img} className='h-10 w-10'/>
                                            <div className=''>
                                                <h1 className='text-xs'>{it.lastname}</h1>
                                                <h1 className='text-sm font-semibold'>{it.username}</h1>
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell>{it.birth_date}</TableCell>
                                    <TableCell>
                                        <Amjiltuud callback={callback} datas={it}/>
                                    </TableCell>
                                    <TableCell>
                                        <div className='flex items-center gap-2'>
                                            <MdDelete className='text-red-500 cursor-pointer' onClick={()=> handleDelete(it.id)}/>
                                            {load && <Spinner size='sm' className='text-red-500 cursor-pointer' />}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
            <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
        </div>
    </div>
  )
}

export default Athletes